import PopoverOnHover from './PopoverOnHover';
import PopoverOnHoverV2 from './PopoverOnHoverV2';
import { withFeatureBranch } from '../../redux/flags';
export default withFeatureBranch({ yumeruby: PopoverOnHoverV2 })(PopoverOnHover);
//# sourceMappingURL=index.js.map